var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":1}),React.createElement("path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z","key":2}),React.createElement("line",{"x1":"12","y1":"11","x2":"12","y2":"17","key":3}),React.createElement("polyline",{"points":"9 14 12 17 15 14","key":4})]);
}

Download.defaultProps = {"className":"icon icon-tabler icon-tabler-file-download","width":"44","height":"44","viewBox":"0 0 24 24","strokeWidth":"1.5","stroke":"#2c3e50","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Download;

Download.default = Download;
